import React, { useState, useCallback, useEffect } from 'react';
import {
  Button, Typography, Box, Chip, Tooltip, IconButton, Modal, TextField, Dialog,
  TableContainer, Table, TableHead, TableRow, TableBody, TablePagination, TableCell
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Colors } from '../../../../Styles/Colors';
import { ImagePaths } from '../../../../Utility/ImagePaths';
import { DateTime } from 'luxon';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { DeletePopup } from '../../../../Components/Common Components/CommonComponents';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import { painLevelTxt } from '../../../../Utility/Constants';
import { formatDate } from '../../../../Components/CommonFunctions/CommonFunctions';

export const renderTitle = (Title, isSelected) => {
  return (<Box display={"flex"} alignItems={"center"} gap={"0.5vw"}>
    {isSelected && <DoubleArrowIcon color='error' sx={{ fontSize: '1.2vw' }} />}
    <Typography fontSize={'1vw'} fontWeight={600} color={Colors.SecondaryText}>{Title}</Typography>
  </Box>)
}

export const renderIconButton = (title, src, onClick, disabled = false, size = "1.1vw") => (
  <Tooltip placement="top" title={title} arrow>
    <span>
      <IconButton onClick={onClick} disabled={disabled}>
        <Box
          component="img"
          src={src}
          height={size}
          width={size}
          alt={title}
        />
      </IconButton>
    </span>
  </Tooltip>
);

export const ActionButton = ({ text, emed_tid = "saras_doc_notes_btn", sx = {}, size = "small",
  variant = "contained", disabled = false, onClick = () => { }, className = "" }) => (
  <Button
    emed_tid={emed_tid}
    sx={{ textTransform: 'capitalize', ...sx }}
    className={className}
    size={size}
    variant={variant}
    disabled={disabled}
    onClick={onClick}
  >
    {text}
  </Button>
);